<template>
  <button
    v-show="currW <= 1500"
    aria-label="Filters"
    class="btn btn-primary btn_filter"
    @click="filterToggle"
  >
    <svg
      height="24"
      width="24"
    >
      <use xlink:href="/icons/sprite.svg#i-filter" />
    </svg>
    <span class="hlgd">{{ $t('filters.filters') }}</span>
  </button>
</template>

<script lang="ts" setup>
import { EventBus } from '~/composables/bus';
import { useResize } from '~/composables/resize.js';

const currW = useResize();

function filterToggle() {
  EventBus.$emit('toggleFilters', { value: true });
}
</script>

<style lang="scss" scoped>
.btn_filter {
  display: none;
  font-weight: 400;
  color: var(--surfaces-on-surface-variable);

  @media screen and (max-width: 1400px) {
    display: flex;
  }
  @media screen and (max-width: 1115px) {
    padding: 0 8px;
  }
}
</style>
